import React, { Component } from "react";
class Payment3DDefault extends Component {
    render() {
        return (<div className="container">
            <h1>Default</h1>
        </div>);
    }
}
export default Payment3DDefault;